"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_delayed_initialization_1 = require("owa-delayed-initialization");
var initCalendarMailboxConfiguration_1 = require("./actions/initCalendarMailboxConfiguration");
// Load initial state needed for options
owa_delayed_initialization_1.runAfterBootstrap(function () {
    initCalendarMailboxConfiguration_1.default();
});
var saveCalendarMailboxConfiguration_1 = require("./actions/saveCalendarMailboxConfiguration");
exports.saveCalendarMailboxConfiguration = saveCalendarMailboxConfiguration_1.default;
var getCalendarConfiguration_1 = require("./utils/getCalendarConfiguration");
exports.getCalendarConfiguration = getCalendarConfiguration_1.default;
var initCalendarMailboxConfiguration_2 = require("./actions/initCalendarMailboxConfiguration");
exports.initCalendarMailboxConfiguration = initCalendarMailboxConfiguration_2.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/owa-calendar-configuration/lib/index.js
// module id = 2730
// module chunks = 2